/* Code for Slick Slider - Multi Column - Redefine*/
$(document).ready(function()
{
   $('.rd-slickslider-1').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    prevArrow: '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',    
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })
  $('.rd-slickslider-2').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 300,
    prevArrow: '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.rd-slickslider-3').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    dots: false,
    prevArrow: '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.rd-slickslider-4').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
    dots: false,
    prevArrow: '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.rd-slickslider-9').slick({
    infinite: false,
    slidesToShow: 9,
    slidesToScroll: 1,
    speed: 300,
    dots: false,
    arrows: false,
    prevArrow: '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});
